(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const panels = new Map();
  const headings = new Map();
  const menus = new Map();
  let frameId = null;

  if (reduceMotion.matches) return;

  const register = (root = document) => {
    const elements = root.matches?.('.footer__panel') ? [root] : [...root.querySelectorAll('.footer__panel')];
    const headingElements = root.matches?.('[data-footer-heading-motion]')
      ? [root]
      : [...root.querySelectorAll('[data-footer-heading-motion]')];
    const menuElements = root.matches?.('[data-footer-menu-motion]')
      ? [root]
      : [...root.querySelectorAll('[data-footer-menu-motion]')];

    elements.forEach((panel) => {
      if (panels.has(panel)) return;

      panel.style.setProperty('--footer-panel-progress', '0');
      panels.set(panel, { current: 0, target: 0 });
    });

    headingElements.forEach((heading) => {
      if (headings.has(heading)) return;

      headings.set(heading, { current: 0, target: 0 });
    });

    menuElements.forEach((menu) => {
      if (menus.has(menu)) return;

      menus.set(menu, { current: 0, target: 0 });
    });

    requestUpdate();
  };

  const update = () => {
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    let keepAnimating = false;

    panels.forEach((state, panel) => {
      if (!panel.isConnected) {
        panels.delete(panel);
        return;
      }

      const bounds = panel.getBoundingClientRect();
      const start = viewportHeight * 0.96;
      const distance = Math.max(viewportHeight * 0.58, 1);
      const rawProgress = Math.max(0, Math.min(1, (start - bounds.top) / distance));

      state.target = 1 - Math.pow(1 - rawProgress, 3);
      state.current += (state.target - state.current) * 0.12;

      if (Math.abs(state.target - state.current) > 0.001) keepAnimating = true;

      panel.style.setProperty('--footer-panel-progress', state.current.toFixed(4));
    });

    headings.forEach((state, heading) => {
      if (!heading.isConnected) {
        headings.delete(heading);
        return;
      }

      const anchor = heading.closest('.footer__featured-navigation') || heading;
      const bounds = anchor.getBoundingClientRect();
      const rawProgress = Math.max(0, Math.min(1, (viewportHeight * 1.02 - bounds.top) / (viewportHeight * 0.68)));

      state.target = 1 - Math.pow(1 - rawProgress, 3);
      state.current += (state.target - state.current) * 0.1;

      if (Math.abs(state.target - state.current) > 0.001) keepAnimating = true;

      const footer = heading.closest('.footer');
      const menu = footer?.querySelector('[data-footer-menu-motion]');
      const menuAnchor = menu?.closest('.footer__featured-navigation-inner');
      const headingBaseLeft = heading.parentElement.getBoundingClientRect().left;
      const menuPaddingLeft = menuAnchor ? Number.parseFloat(window.getComputedStyle(menuAnchor).paddingLeft) || 0 : 0;
      const menuFinalLeft = menuAnchor
        ? menuAnchor.getBoundingClientRect().left + menuPaddingLeft - Math.min(viewportWidth * 0.035, 48)
        : headingBaseLeft;
      const finalOffset = menuFinalLeft - headingBaseLeft;
      const offset = finalOffset + viewportWidth * 0.65 * (1 - state.current);
      heading.style.setProperty('--footer-heading-x', `${offset.toFixed(2)}px`);
    });

    menus.forEach((state, menu) => {
      if (!menu.isConnected) {
        menus.delete(menu);
        return;
      }

      const anchor = menu.closest('.footer__featured-navigation-inner') || menu;
      const bounds = anchor.getBoundingClientRect();
      const rawProgress = Math.max(0, Math.min(1, (viewportHeight * 0.98 - bounds.top) / (viewportHeight * 0.68)));

      state.target = 1 - Math.pow(1 - rawProgress, 3);
      state.current += (state.target - state.current) * 0.1;

      if (Math.abs(state.target - state.current) > 0.001) keepAnimating = true;

      const scale = 1 - state.current * 0.75;
      const offset = -Math.min(viewportWidth * 0.035, 48) * state.current;
      const anchorStyles = window.getComputedStyle(anchor);
      const paddingTop = Number.parseFloat(anchorStyles.paddingTop) || 0;
      const paddingBottom = Number.parseFloat(anchorStyles.paddingBottom) || 0;
      const layoutHeight = paddingTop + menu.scrollHeight * scale + paddingBottom;
      menu.style.setProperty('--footer-menu-scale', scale.toFixed(4));
      menu.style.setProperty('--footer-menu-x', `${offset.toFixed(2)}px`);
      anchor.style.height = `${layoutHeight.toFixed(2)}px`;
    });

    frameId = keepAnimating ? window.requestAnimationFrame(update) : null;
  };

  function requestUpdate() {
    if (frameId === null) frameId = window.requestAnimationFrame(update);
  }

  register();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', (event) => register(event.target));
  document.addEventListener('shopify:section:unload', requestUpdate);
})();
